<template>
  <div>
    <textarea :id="editorId"></textarea>
  </div>
</template>

<script>
import FroalaEditor from 'froala-editor'
require('froala-editor/js/froala_editor.pkgd.min.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')
// Core JS + plugins
import 'froala-editor/js/froala_editor.pkgd.min.js'
import 'froala-editor/js/plugins/colors.min.js'
import 'froala-editor/js/plugins/emoticons.min.js'
import 'froala-editor/js/plugins/special_characters.min.js'
import 'froala-editor/js/plugins/print.min.js'
import 'froala-editor/js/plugins/align.min.js'   // ✅ alignment buttons
import 'froala-editor/js/plugins/font_family.min.js'
import 'froala-editor/js/plugins/font_size.min.js'
import 'froala-editor/js/plugins/link.min.js'

// Core CSS + plugin CSS
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/plugins/colors.min.css'
import 'froala-editor/css/plugins/emoticons.min.css'
import 'froala-editor/css/plugins/special_characters.min.css'
//import 'froala-editor/css/plugins/print.min.css'
//import 'froala-editor/css/plugins/align.min.css'   // ✅ alignment CSS

export default {
  name: 'FroalaWrapper',
  props: {
    value: { type: String, default: '' },
    config: { type: Object, default: () => ({}) },
    tokenList: { type: Array, default: () => [] } // [{name, tagtext}]
  },
  data() {
    return {
      editor: null,
      editorId: `froala-${Math.random().toString(36).substr(2, 9)}`,
      tokenKeys: []
    }
  },
  mounted() {
    this.initEditor()
  },
  watch: {
    value(newVal) {
      if (this.editor && newVal !== this.editor.html.get()) {
        this.editor.html.set(newVal)
      }
    },
    tokenList: {
      handler() {
        if (this.editor) this.addDynamicTokens()
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    normalizeName(name) {
      return name.replace(/\s+/g, '_')
    },

    registerTokenCommand(t) {
      const key = this.normalizeName(t.name)
      if (this.tokenKeys.includes(t.name)) return
      this.tokenKeys.push(t.name)

      FroalaEditor.DefineIcon('insert', { NAME: 'plus' , SVG_KEY: 'add'}) // simple icon
      FroalaEditor.RegisterCommand(t.name, {
        title: t.name,
        focus: true,
        undo: true,
        refreshAfterCallback: true,
        callback: function () {
          this.html.insert(t.tagtext)
        }
      })
    },

    buildToolbarButtons() {
      let baseButtons = this.config.toolbarButtons || []
      baseButtons = Array.isArray(baseButtons[0]) ? [].concat(...baseButtons) : baseButtons
      return [...baseButtons, ...this.tokenKeys] // append dynamic token buttons
    },

    initEditor() {
      const vm = this

      // 1. Register all token buttons
      this.tokenList.forEach(t => vm.registerTokenCommand(t))

      // 2. Build toolbar
      const allButtons = this.buildToolbarButtons()

      // 3. Initialize Froala editor
      const options = {
        ...this.config,
        toolbarButtons: allButtons,
        toolbarButtonsMD: allButtons,
        toolbarButtonsSM: allButtons,
        toolbarButtonsXS: allButtons,
        events: {
          ...this.config.events,
          initialized: function () {
            vm.editor = this
            if (vm.value) this.html.set(vm.value)
          },
          contentChanged: function () {
            if (vm.editor) {
              const newContent = vm.editor.html.get()
              vm.$emit('input', newContent)
              vm.$emit('change', newContent)
            }
          }
        }
      }

      this.editor = new FroalaEditor(`#${this.editorId}`, options)
    },

    addDynamicTokens() {
      if (!this.editor) return
      // register new tokens
      this.tokenList.forEach(t => this.registerTokenCommand(t))

      // rebuild toolbar so new buttons appear
      const allButtons = this.buildToolbarButtons()
      this.editor.opts.toolbarButtons = allButtons
      this.editor.opts.toolbarButtonsMD = allButtons
      this.editor.opts.toolbarButtonsSM = allButtons
      this.editor.opts.toolbarButtonsXS = allButtons

      if (this.editor.toolbar) {
        this.editor.toolbar.refresh()
      }
    }
  }
}
</script>
<style>
.fr-sr-only{
  height:40px;
}
</style>